import React, {
  useContext,
  useEffect,
  useState,
  useRef,
  useCallback,
} from "react";
import Rating from "@mui/material/Rating";
import RatingComp from "../../../../components/Multiple/RatingComp";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../Files/BaseURL";
import { formatDateForInput } from "../../../../Files/UseFunction";
import axios from "axios";
import SocketContext from "../../../../Context/Socket/SocketContext";
import {
  FaDownload,
  FaFileAlt,
  FaFileImage,
  FaFileVideo,
  FaRegFilePdf,
  FaTimes,
} from "react-icons/fa";
import { BsFiletypeDocx } from "react-icons/bs";
import { MdFolderZip } from "react-icons/md";
import ThemeContext from "../../../../Context/theme/ThemeContext";
import pdfImage from "../../../../assets/pdf_icon.png";
import ScrollToBottom from "react-scroll-to-bottom";

const RequestResponseUser = () => {
  const { theme } = useContext(ThemeContext);
  const location = useLocation();

  const [Profile, setProfile] = useState(null);
  const [Skills, setSkills] = useState(null);
  const [Portfolio, setPortfolio] = useState(null);
  const [Conversation, setConversation] = useState([]);
  const [TotalPages, setTotalPages] = useState(null);
  const [Page, setPage] = useState(null);
  const [message, setmessage] = useState("");
  const [ChatFile, setChatFile] = useState(null);
  const [FileName, setFileName] = useState(null);
  const [UploadedFile, setUploadedFile] = useState(null);

  const { jobId, userId } = useParams();

  const navigate = useNavigate();

  const alertcontext = useContext(AlertContext);
  const { showAlert } = alertcontext;

  const socketcontext = useContext(SocketContext);
  const { OnlineUsers, SocetConnection, isUserOnline } = socketcontext;
  const [response, setResponses] = useState();
  const [job, setJob] = useState();
  const [style, setStyle] = useState();
  const [reviews, setReviews] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const scrollContainerRef = useRef(null);

  const getReviews = async () => {
    try {
      const result = await axios.get(
        `${BaseURL}/api/review/getReviews/${userId}/${5}`,
        {
          headers: {
            "auth-token": localStorage.getItem("p@token"),
          },
        }
      );
      if (result.status === 200) {
        setReviews(result.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getJob = async () => {
    try {
      const res = await axios.get(
        `${BaseURL}/api/requestjob/getJobDetails/${jobId}`,
        {
          headers: {
            "auth-token": localStorage.getItem("p@token"),
          },
        }
      );
      if (res.status === 200) {
        setJob(res.data.job);
        setStyle(res.data.styleData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getResponses = async () => {
    const authToken = localStorage.getItem("p@token");
    try {
      const response = await fetch(
        `${BaseURL}/api/requestjob/getFilteredResponses/${jobId}/${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "auth-token": authToken,
          },
        }
      );

      if (response.ok) {
        const result = await response.json();
        setResponses(result);
      } else {
        showAlert("Error fetching job details", "danger");
      }
    } catch (error) {
      showAlert("Network Error", "danger");
    }
  };

  const getUserDetail = async () => {
    try {
      const res = await axios.get(`${BaseURL}/api/getusers/getuser/${userId}`, {
        headers: {
          "auth-token": localStorage.getItem("p@token"),
        },
      });
      if (res.status === 200) {
        setProfile(res.data.user);
      } else {
        showAlert("User info does not found", "danger");
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchconversation = async (pageNum = 1) => {
    try {
      const authToken = localStorage.getItem("p@token");
      const response = await axios.get(
        `${BaseURL}/api/messaging/getMessagesbyuser/${userId}?page=${pageNum}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": authToken,
          },
        }
      );

      if (response.data.success) {
        if (pageNum === 1) {
          setConversation(response.data.messages);
        } else {
          setConversation((prev) => [...response.data.messages, ...prev]);
        }
        setTotalPages(response.data.totalPages);
        setPage(response.data.page);
      } else {
        if (response.data.sameuser) {
          setConversation(null);
        } else {
          showAlert(response.data.message, "danger");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleScroll = useCallback(async () => {
    const container = scrollContainerRef.current;
    if (!container || isLoading || Page >= TotalPages) return;

    const { scrollTop } = container;

    if (scrollTop === 0) {
      setIsLoading(true);
      await fetchconversation(Page + 1);
      setIsLoading(false);

      // Maintain scroll position
      const newHeight = container.scrollHeight;
      container.scrollTop = newHeight - container.clientHeight;
    }
  }, [isLoading, Page, TotalPages]);

  useEffect(() => {
    if (SocetConnection) {
      const handleMessage = (data) => {
        fetchconversation();
      };

      // Attach the event handler
      SocetConnection.on("message", handleMessage);

      // Cleanup function to remove the event handler
      return () => {
        SocetConnection.off("message", handleMessage);
      };
    }
  }, [SocetConnection, location.search]);

  useEffect(() => {
    if (userId) {
      fetchconversation();
      getResponses();
      getUserDetail();
      getJob();
      getReviews();
    }
  }, [userId]);

  const handleSendMessage = async (e) => {
    if (userId) {
      if (message !== "") {
        if (SocetConnection) {
          await SocetConnection.emit("new message", {
            UserID: userId,
            covnersation: message,
            File: {
              Link: UploadedFile,
              Name: FileName,
            },
          });
          setmessage("");
          setUploadedFile(null);
          setFileName(null);
          setChatFile(null);
        }
      }
    }
  };

  const formatDate = (timeStamp) => {
    const date = new Date(timeStamp);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    return `${day}-${month}-${year}`;
  };

  const FileUpload = async (e) => {
    try {
      const file = e.target.files[0];
      setChatFile(file);
      setFileName(file.name);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("filename", file.name);

      const authToken = localStorage.getItem("p@token");
      const response = await fetch(`${BaseURL}/api/messaging/upload-docs`, {
        method: "POST",
        headers: {
          "auth-token": authToken,
        },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        setUploadedFile(data?.location);
      } else {
        showAlert("File not uploaded, try again", "danger");
      }
    } catch (error) {
      console.error("File upload error:", error);
      showAlert("File not uploaded, try again", "danger");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSendMessage();
    }
  };
  const renderFileIcon = (file) => {
    const fileType = file;

    switch (fileType) {
      case "image":
        return <FaFileImage className="text-2xl w-full text-primarygreen" />;
      case "video":
        return <FaFileVideo className="text-2xl w-full text-primarygreen" />;
      case "pdf":
        return <FaRegFilePdf className="text-2xl w-full text-red-500" />;
      case "application":
        return <FaRegFilePdf className="text-2xl w-full text-red-500" />;
      case "doc":
        return <BsFiletypeDocx className="text-2xl w-full text-blue-500" />;
      case "docx":
        return <BsFiletypeDocx className="text-2xl w-full text-blue-500" />;
      case "zip":
        return <MdFolderZip className="text-2xl w-full text-gray-400" />;
      default:
        return <FaFileAlt className="text-2xl w-full text-primarygreen" />;
    }
  };

  return (
    <div className="w-[95%] m-auto py-6 flex flex-col gap-6">
      <div className="flex flex-col lg:flex-row gap-6">
        <div
          className={`basis-[70%]  flex flex-col gap-6 rounded-2xl py-6 px-4 ${
            theme == "dark" ? "bg-black text-white" : "bg-white "
          }`}
        >
          <div className="flex flex-col lg:flex-row justify-between gap-6 lg:gap-2">
            <div className="flex flex-col md:flex-row font-pop items-center gap-2">
              {/*<div>*/}
              {/*    <img src={Profile?.ProfilePhoto} alt="" className='w-24 h-24 rounded-full' />*/}
              {/*</div>*/}
              <div>
                {Profile?.ProfilePhoto ? (
                  <img
                    src={Profile?.ProfilePhoto}
                    alt=""
                    className="rounded-full w-8 md:w-12 h-8 md:h-12"
                  />
                ) : (
                  <div className="w-8 md:w-12 h-8 md:h-12 rounded-full font-pop bg-gray-400 flex items-center justify-center">
                    <span className={`text-white `}>
                      {Profile && Profile?.FirstName?.charAt(0)}
                    </span>
                  </div>
                )}
              </div>

              <div className="flex flex-col gap-1 md:gap-2">
                <div className="flex flex-row gap-1 items-center">
                  <img
                    alt="tick-icon"
                    src="/Assets/Prop/badge.png"
                    className="w-6 h-6"
                  />
                  <h4
                    className={`text-base text-lightGrey ${
                      theme == "dark" && "text-white"
                    }`}
                  >
                    Level {Profile?.Level}
                  </h4>
                </div>
                <h3 className="text-2xl font-semibold">
                  {Profile?.FirstName} {Profile?.LastName}
                </h3>
                <h4
                  className={`text-lg text-lightGrey   ${
                    theme == "dark" && "text-white"
                  }`}
                >
                  @{Profile?.FirstName}
                  {Profile?.LastName}
                </h4>
              </div>
            </div>
            <div className="flex flex-col lg:text-right font-pop gap-2">
              <h2
                className={` text-lightGrey font-medium ${
                  theme == "dark" && "text-white"
                }`}
              >
                <span className="font-light">Last seen: </span>5 hours ago
              </h2>
              <h2
                className={` text-lightGrey font-medium ${
                  theme == "dark" && "text-white"
                }`}
              >
                <span className="font-light">Local time: </span>United Kingdom,
                10 Mar 2024, 19:24
              </h2>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <div className="flex flex-col font-pop gap-1">
              <h4
                className={`text-lightGrey font-medium ${
                  theme == "dark" && "text-white"
                }`}
              >
                Location
              </h4>
              <h3 className="font-normal">{Profile?.Homeaddress?.Country}</h3>
            </div>
            <div className="flex flex-col font-pop gap-1">
              <h4
                className={` text-lightGrey font-medium ${
                  theme == "dark" && "text-white"
                }`}
              >
                Skills
              </h4>
              <div className="flex flex-row flex-wrap font-pop gap-1">
                {Skills?.map((item, index) => (
                  <div
                    className={` rounded-full py-1 px-2 text-base ${
                      theme == "dark" ? "bg-black text-white" : "bg-white "
                    } `}
                    key={index}
                  >
                    {item?.name}
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col font-pop gap-1">
              <h4
                className={`text-lightGrey font-medium ${
                  theme === "dark" && "text-white"
                }`}
              >
                Languages
              </h4>
              {Profile?.Languages.map((item, index) => (
                <div
                  key={index}
                  className="flex flex-row flex-wrap font-pop gap-1"
                >
                  <div
                    className={`rounded-full py-1 px-2 text-base ${
                      theme === "dark" ? "bg-black text-white" : "bg-white"
                    }`}
                  >
                    {item}
                  </div>
                </div>
              ))}
            </div>
            <div className="flex flex-col font-pop gap-1">
              <h4
                className={` text-lightGrey font-medium ${
                  theme == "dark" && "text-white"
                }`}
              >
                Rating
              </h4>
              <div
                className={` bg-[#FEF8EE] font-medium py-1 px-2 h-fit w-fit flex flex-row items-center gap-2 text-black rounded-3xl ${
                  theme == "dark" ? "bg-black text-white" : "bg-white "
                }`}
              >
                {Number(Profile?.Rating).toFixed(1)}{" "}
                <Rating
                  name="read-only"
                  precision={0.1}
                  value={Number(Profile?.Rating).toFixed(1)}
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className={`basis-[30%] flex flex-col justify-between gap-4 rounded-2xl py-6 px-4 ${
            theme == "dark" ? "bg-black text-white" : "bg-white "
          }`}
        >
          <h3
            className={`border-b-2 border-light text-center pb-4 text-lightGrey font-pop ${
              theme == "dark" && "text-white"
            }`}
          >
            Latest reviews for this seller
          </h3>
          <div className="flex flex-col font-pop gap-2 max-h-72 overflow-y-auto py-4">
            {reviews &&
              reviews?.map((item, index) => (
                <RatingComp
                  key={index}
                  FirstName={item?.reviewedBy.FirstName}
                  LastName={item?.reviewedBy.LastName}
                  ProfileImage={item?.reviewedBy.ProfilePhoto}
                  Country={item?.reviewedBy.Homeaddress.Country}
                  rating={item?.rating}
                  reviewMessage={item?.review}
                  date={item?.date}
                />
              ))}
          </div>
          <div
            className="border-2 font-pop w-full text-center font-medium border-light py-2 px-4 rounded-full"
            onClick={() => {
              navigate(`/user-dashboard/rating/${userId}`);
            }}
          >
            See all Reviews
          </div>
        </div>
      </div>

      <div className={`flex flex-col lg:flex-row font-pop`}>
        <div
          className={`min-w-[50%] w-md mr-0 lg:mr-5 p-4 shadow-lg rounded-lg my-2  ${
            theme === "dark"
              ? "bg-black text-white"
              : "bg-white lg:block hidden"
          }`}
        >
          <h2 className="text-lightGrey text-lg font-medium mb-4 text-center font-pop">
            Job Request Description
          </h2>
          <hr className={`p-3`} />
          <div className="space-y-2 px-5">
            <div className="flex justify-between">
              <span className="text-lightGrey font-medium font-pop">
                Price:
              </span>
              <div className={"w-[30%]"}>
                <span className="font-pop font-medium text-[#06050B]">
                  ${job?.amount}
                </span>
              </div>
            </div>
            <div className="flex justify-between">
              <span className="text-lightGrey font-medium font-pop">
                Delivery Date:
              </span>
              <div className={"w-[30%]"}>
                <span className="font-pop font-medium text-[#06050B]">
                  {formatDate(job?.DeliveryDate)}
                </span>
              </div>
            </div>
            <div className="flex justify-between">
              <span className="text-lightGrey font-medium font-pop">
                Service:
              </span>
              <div className={"w-[30%]"}>
                <span className="font-pop font-medium text-[#06050B]">
                  {style?.skill}
                </span>
              </div>
            </div>
            <div className="flex justify-between">
              <span className="text-lightGrey font-medium font-pop">
                Category:
              </span>
              <div className={"w-[30%]"}>
                <span className="font-pop font-medium text-[#06050B]">
                  {job?.Category?.name}
                </span>
              </div>
            </div>
            <div className="flex">
              <span className="text-lightGrey font-medium mr-3 font-pop">
                Description:
              </span>
              <span className="leading-relaxed mt-5 font-pop text-[#06050B]">
                {job?.Description}
              </span>
            </div>
          </div>
        </div>

        <div
          className={`min-w-[50%] w-md mr-0 lg:mr-5 p-4 shadow-lg rounded-lg my-2  ${
            theme === "dark" ? "bg-black text-white" : "bg-white "
          }`}
        >
          <h2 className="text-lightGrey text-lg font-medium mb-4 text-center font-pop">
            Job Response by User
          </h2>
          <hr className={`p-3`} />
          <div className="space-y-2 px-5">
            <div className="flex justify-between">
              <span className="text-lightGrey font-medium font-pop">
                Price:
              </span>
              <div className={"lg:w-[20%]"}>
                <span className="font-pop font-medium text-[#06050B] ">
                  ${response?.amount}
                </span>
              </div>
            </div>
            <div className="flex justify-between">
              <span className="text-lightGrey font-medium font-pop">
                Delivery Date:
              </span>
              <div className={"lg:w-[20%]"}>
                <span className="font-pop font-medium text-[#06050B] ">
                  {formatDate(response?.date)}
                </span>
              </div>
            </div>

            <div className="flex overflow-y-auto">
              <span className="text-lightGrey font-medium font-pop">
                Message:
              </span>
              <span className="p-2 font-pop font-medium text-[#06050B] break-all ">
                {response?.message}
              </span>
            </div>

            <div className="flex">
              <span className="text-lightGrey font-medium lg:mr-3 font-pop">
                Attached Documents:
              </span>

              {response?.attachFile.map((file, index) => (
                <div key={index} className={"leading-relaxed mt-10 px-1"}>
                  <a href={file.src} download>
                    <img src={pdfImage} alt="file-preview" />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {Conversation !== null && (
        <div
          className={`rounded-2xl py-6 px-6 ${
            theme == "dark" ? "bg-black text-white" : "bg-white text-black"
          }`}
        >
          <div className="flex flex-col gap-6 h-[100%] justify-between">
            <div
              className="h-[60vh] overflow-y-auto overflow-x-hidden"
              ref={scrollContainerRef}
              onScroll={handleScroll}
            >
              {isLoading && (
                <div className="text-center py-2">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primarygreen mx-auto"></div>
                </div>
              )}
              <div className="flex flex-col gap-2">
                {Conversation?.length > 0 &&
                  Conversation?.map((item, index) => (
                    <div
                      key={index}
                      className={`${
                        item.tag == "Sender"
                          ? "flex flex-col items-end"
                          : "flex flex-col items-start"
                      } my-1 gap-1 w-full`}
                    >
                      {item?.File?.Link && (
                        <div
                          className={`p-2 rounded w-fit max-w-[80%] shadow-md font-pop flex items-end ${
                            item.tag == "Sender"
                              ? "bg-primarygreen/50 text-white"
                              : "bg-gray-300 text-black"
                          }`}
                        >
                          <div className="flex flex-col gap-2">
                            {item?.File && renderFileIcon(item?.File?.Link)}
                            <span className="ml-2">{item?.File?.Name}</span>
                          </div>
                          <a
                            href={item?.File?.Link}
                            download={true}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaDownload className="ml-2 text-3xl text-gray-500 cursor-pointer" />
                          </a>
                        </div>
                      )}
                      <div
                        className={`${
                          item.tag == "Sender"
                            ? "bg-primarygreen text-white"
                            : "bg-[#E8E8E8] text-black"
                        } rounded-xl py-2 px-3 max-w-[80%] break-words`}
                      >
                        <p
                          className={`text-sm md:text-base ${
                            theme == "dark" && "text-white"
                          }`}
                        >
                          {item?.message}
                        </p>
                      </div>
                      <p
                        className={`${
                          item.tag == "Sender" ? "text-right" : "text-left"
                        } text-xs w-full`}
                      >
                        {formatDateForInput(item?.date)}
                      </p>
                    </div>
                  ))}
              </div>
            </div>
            <div
              className={`flex flex-row font-pop justify-between items-center ${
                theme == "dark"
                  ? "bg-gray-700 text-white"
                  : "bg-[#E8E8E8] text-black"
              } rounded-2xl py-1 md:py-2 px-2 md:px-4`}
            >
              <div className="flex w-[100%] flex-row items-center gap-2">
                <label htmlFor="fileupload" className="relative">
                  <img
                    src="../../../../../Assets/Prop/docattach.png"
                    alt=""
                    className="w-8 h-8"
                  />
                  <input
                    type="file"
                    id="fileupload"
                    onChange={FileUpload}
                    className="hidden"
                  />
                </label>
                <div className="flex gap-2 w-full">
                  {UploadedFile !== "" && UploadedFile !== null && (
                    <div className="bg-gray-300 p-2 rounded shadow-md font-pop flex items-center">
                      <div className="flex flex-col gap-2">
                        {ChatFile && renderFileIcon(ChatFile)}
                        <span className="ml-2 w-max text-xs">{FileName}</span>
                      </div>
                      <FaTimes
                        className="ml-2 text-red-500 cursor-pointer"
                        onClick={() => {
                          setChatFile(null);
                          setFileName(null);
                          setUploadedFile(null);
                        }}
                      />
                    </div>
                  )}
                  <input
                    type="text"
                    value={message}
                    onChange={(e) => {
                      setmessage(e.target.value);
                    }}
                    placeholder="Message..."
                    onKeyDown={(e) => handleKeyDown(e)}
                    className={`text-lg w-[100%] font-normal border-transparent outline-none focus:outline-none focus:border-transparent active:border-transparent active:outline-none bg-transparent ${
                      theme == "dark" ? "text-white" : "text-black"
                    }`}
                  />
                </div>
              </div>
              <img
                src="../../../../../Assets/Prop/messagesend.png"
                alt=""
                onClick={handleSendMessage}
                className="w-4 h-4 md:w-8 md:h-8 cursor-pointer"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RequestResponseUser;